import { api } from './api';

/**
 * ============================================================================
 * LEADS — vinham de um TERCEIRO banco
 * ============================================================================
 *
 * Este arquivo substitui `lib/supabaseExternal.ts` e a duplicata morta
 * `lib/externalSupabase.ts` (que ainda tinha URL e chave literais no código, sem
 * nenhum importador).
 *
 * A base "externa" de leads era um projeto Supabase separado, com credencial
 * própria no bundle do navegador — o quarto banco distinto que este repositório
 * alcançava. Agora é a mesma API e a mesma tabela `leads` que a captação
 * (`nyroh-leads`) escreve: um lead, um lugar.
 */

/** Forma que `ExternalLeads.tsx` já consome. Mantida para não reescrever a tela. */
export interface ExternalLead {
  id: string;
  name: string;
  category: string;
  rating: number;
  reviews: number;
  phone: string;
  address: string;
  city: string;
  state: string;
  whatsappStatus: string;
  whatsapp_status: string;
  /** Formato vem da Evolution API e muda sem aviso; propositalmente frouxo. */
  whatsappData: any;
  whatsapp_data: any;
  createdAt: string;
  catalog?: unknown[];
}

/**
 * Busca leads.
 *
 * O `.limit(50)` da versão antiga vira o parâmetro `limite` do contrato — mas
 * agora o teto é do SERVIDOR, não uma gentileza do cliente. Uma chamada sem
 * limite não existe mais nesta API.
 */
export async function buscarLeads(limite = 50): Promise<ExternalLead[]> {
  const pagina = await api.chamar('leads.listar', {
    query: { limite: Math.min(limite, 200) },
  });

  return pagina.itens.map((l) => {
    const partes = (l.endereco ?? '').split(',').map((s) => s.trim());
    const wa = l.dadosWhatsapp as { status?: string } | null;
    return {
      id: l.placeId,
      name: l.nome,
      category: l.tipos[0] ?? '',
      rating: l.nota ?? 0,
      reviews: l.totalAvaliacoes ?? 0,
      phone: l.telefone ?? '',
      address: l.endereco ?? '',
      city: partes.at(-2) ?? '',
      state: partes.at(-1) ?? '',
      whatsappStatus: wa?.status ?? '',
      whatsapp_status: wa?.status ?? '',
      whatsappData: l.dadosWhatsapp,
      whatsapp_data: l.dadosWhatsapp,
      createdAt: l.varridoEm,
    };
  });
}
